// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "@/store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import axios from 'axios';

// 全局方法挂载
//Vue.prototype.$axios = axios;

Vue.use(ElementUI);

Vue.config.productionTip = false

// 自定义指令
Vue.directive('hasBtn', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted(el, bindings, vnode) {
    let value = bindings.value;
    // 在vuex中查看是否有按钮权限
    let flag = vnode.context.$store.state.btnPermission[value];
    // 如果没有权限则将按钮删除
    !flag && el.parentNode.removeChild(el);
  }
})

// 国际化配置
import {initI18n, i18n} from '@/utils/i18nUtil.js';
initI18n();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js